
export function f_en_and_y(text) {
    return `

    <div class=WordSection1>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt'><b><span
    style='font-size:24.0pt;font-family:"Zilla Slab",serif;color:black;letter-spacing:
    .75pt'>en and y</span></b></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt'><b><span
    style='font-size:24.0pt;font-family:"Zilla Slab",serif;color:black;letter-spacing:
    .75pt'>&nbsp;</span></b></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal'><span
    style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;and&nbsp;</span><b><span style='font-size:12.0pt;font-family:
    "inherit",serif;color:#B71533'>y</span></b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;do not usually refer to people.
    How we translate them into English depends on where&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>en</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;and&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>y</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;are
    found in French.</span></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>1&nbsp;</span></u></b><b><u><span style='font-size:16.0pt;
    font-family:"inherit",serif;color:#B71533'>en</span></u></b></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;is used with verbs and phrases normally followed by&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>de</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;to avoid
    repeating the same word.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Si tu as un probl&egrave;me, tu peux m’en&nbsp;parler.</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>If you’ve
      got a problem, you can talk to me about it. </span><span lang=FR
      style='font-size:12.0pt;font-family:"inherit",serif'>(<b><i><span
      style='color:#B71533'>en</span></i></b>&nbsp;<i>replaces</i>&nbsp;<b><i><span
      style='color:#B71533'>de</span></i></b>&nbsp;<i>in</i>&nbsp;<b><i><span
      style='color:#B71533'>parler</span></i></b>&nbsp;<b><i><span
      style='color:#B71533'>de quelque chose</span></i></b>)</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Est-ce que tu peux me pr&ecirc;ter ce livre? </span></b><b><span
      style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>J’en&nbsp;ai
      besoin.</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Can you
      lend me that book? </span><span lang=FR style='font-size:12.0pt;font-family:
      "inherit",serif'>I need it. (<b><i><span style='color:#B71533'>en</span></i></b>&nbsp;<i>replaces</i>&nbsp;<b><i><span
      style='color:#B71533'>de</span></i></b>&nbsp;<i>in</i>&nbsp;<b><i><span
      style='color:#B71533'>avoir besoin</span></i></b>&nbsp;<b><i><span
      style='color:#B71533'>de quelque chose</span></i></b>)</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Il a un beau jardin et il</span></b><span lang=FR
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b><span
      style='color:#B71533'>en&nbsp;est tr&egrave;s fier.</span></b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>He’s got a
      beautiful garden and is very proud of it. </span><span lang=FR
      style='font-size:12.0pt;font-family:"inherit",serif'>(<b><i><span
      style='color:#B71533'>en</span></i></b>&nbsp;<i>replaces</i>&nbsp;<b><i><span
      style='color:#B71533'>de</span></i></b>&nbsp;<i>in</i>&nbsp;<b><i><span
      style='color:#B71533'>&ecirc;tre fier</span></i></b>&nbsp;<b><i><span
      style='color:#B71533'>de quelque chose</span></i></b>)</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span lang=FR style='font-size:10.0pt;font-family:
    Symbol;color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>en</span></b><span lang=FR style='font-size:12.0pt;font-family:
    "inherit",serif;color:black'>&nbsp;can also replace the&nbsp;partitive article&nbsp;(</span><b><span
    lang=FR style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>du</span></b><span
    lang=FR style='font-size:12.0pt;font-family:"inherit",serif;color:black'>,</span><b><span
    lang=FR style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;de
    la</span></b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>,</span><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;de l’</span></b><span lang=FR style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>,</span><b><span lang=FR
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;des</span></b><span
    lang=FR style='font-size:12.0pt;font-family:"inherit",serif;color:black'>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Je n’ai pas d’argent. Tu</span></b><span lang=FR
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b><span
      style='color:#B71533'>en&nbsp;as?</span></b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I haven’t
      got any money. Have you got any?</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>‘Tu peux me pr&ecirc;ter des timbres?’ – ‘Non, je dois</span></b><span
      lang=FR style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b><span
      style='color:#B71533'>en&nbsp;acheter.’</span></b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>‘Can you
      lend me some stamps?’ – ‘No, I have to buy some.’</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:white'><span lang=FR style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on the</span></i><span lang=FR
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;<b><i>Partitive
    article</i></b><i>, see&nbsp;</i></span><i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'><a
    href="https://grammar.collinsdictionary.com/french-easy-learning/the-partitive-article-du-de-la-de-l-and-des"
    title="Explanation of The partitive article: du, de la, de l’ and des"><span
    lang=FR style='color:blue;text-decoration:none'>The partitive article: du, de
    la, de l’ and des</span></a></span></i><i><span lang=FR style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>.</span></i></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;is also used:</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>as a preposition</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>with the present participle of verbs</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on</span></i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;<b><i>Prepositions</i></b>&nbsp;<i>and
    the</i>&nbsp;<b><i>Present participle</i></b><i>, see&nbsp;<a
    href="https://grammar.collinsdictionary.com/french-easy-learning/prepositions"
    title="Explanation of Prepositions"><span style='color:blue;text-decoration:
    none'>Prepositions</span></a>&nbsp;and&nbsp;<a
    href="https://grammar.collinsdictionary.com/french-easy-learning/the-present-participle"
    title="Explanation of The present participle"><span style='color:blue;
    text-decoration:none'>The present participle</span></a>.</i></span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>When&nbsp;</span><b><span style='font-size:12.0pt;font-family:
    "inherit",serif;color:#B71533'>en</span></b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;is used with&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>avoir</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>, with&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>il y a</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;or with
    numbers, it is often not translated in English but can&nbsp;NEVER&nbsp;be
    missed out in French.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>‘Est-ce que tu as un dictionnaire?’ – ‘Oui, j’en</span></b><span
      lang=FR style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b><span
      style='color:#B71533'>ai un.’</span></b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>‘Have you
      got a dictionary?’ – ‘Yes, I’ve got one.’</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>‘Combien d’él&egrave;ves y a-t-il dans ta classe?’ – ‘Il y</span></b><span
      lang=FR style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b><span
      style='color:#B71533'>en&nbsp;a trente.’</span></b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>‘How many
      pupils are there in your class?’ – ‘There are thirty.’</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>J’en&nbsp;veux deux.</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I want two
      (of them).</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>2&nbsp;</span></u></b><b><u><span style='font-size:16.0pt;
    font-family:"inherit",serif;color:#B71533'>y</span></u></b></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>y</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;is used with verbs and phrases normally followed by&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&agrave;</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;to avoid
    repeating the same word.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>‘Je pensais &agrave; l’examen.’ – ‘Mais arr&ecirc;te
      d’y&nbsp;penser!’</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>‘I was
      thinking about the exam.’ – ‘Well, stop thinking about it!’ (<b><i><span
      style='color:#B71533'>y</span></i></b>&nbsp;<i>replaces</i>&nbsp;<b><i><span
      style='color:#B71533'>&agrave;</span></i></b>&nbsp;<i>in</i>&nbsp;<b><i><span
      style='color:#B71533'>penser</span></i></b>&nbsp;<b><i><span
      style='color:#B71533'>&agrave; quelque chose</span></i></b>)</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>‘Je ne m’attendais pas &agrave; ça.’ – ‘Moi, je
      m’y&nbsp;attendais.’</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>‘I wasn’t
      expecting that.’ – ‘Well, I was expecting it.’ </span><span lang=FR
      style='font-size:12.0pt;font-family:"inherit",serif'>(<b><i><span
      style='color:#B71533'>y</span></i></b>&nbsp;<i>replaces</i>&nbsp;<b><i><span
      style='color:#B71533'>&agrave;</span></i></b>&nbsp;<i>in</i>&nbsp;<b><i><span
      style='color:#B71533'>s’attendre</span></i></b>&nbsp;<b><i><span
      style='color:#B71533'>&agrave; quelque chose</span></i></b>)</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>y</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;can also mean&nbsp;<i>there</i>. It can be used to replace
    phrases that would use prepositions such as&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>dans</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;(meaning&nbsp;<i>in</i>)
    and&nbsp;</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>sur</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;(meaning&nbsp;<i>on</i>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Elle</span></b><span lang=FR style='font-size:12.0pt;
      font-family:"inherit",serif'>&nbsp;<b><span style='color:#B71533'>y&nbsp;passe
      tout l’été.</span></b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>She spends
      the whole summer there.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Regarde dans le tiroir. Je pense que les clés</span></b><span
      lang=FR style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b><span
      style='color:#B71533'>y&nbsp;sont.</span></b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Look in
      the drawer. I think the keys are in there.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>3&nbsp;Word order with&nbsp;</span></u></b><b><u><span
    style='font-size:16.0pt;font-family:"inherit",serif;color:#B71533'>en</span></u></b><b><u><span
    style='font-size:16.0pt;font-family:"inherit",serif;color:black'>&nbsp;and&nbsp;</span></u></b><b><u><span
    style='font-size:16.0pt;font-family:"inherit",serif;color:#B71533'>y</span></u></b></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;and&nbsp;</span><b><span style='font-size:12.0pt;font-family:
    "inherit",serif;color:#B71533'>y</span></b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;usually come&nbsp;BEFORE&nbsp;the
    verb.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>J’en&nbsp;veux.</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I want
      some.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Elle</span></b><span lang=FR style='font-size:12.0pt;
      font-family:"inherit",serif'>&nbsp;<b><span style='color:#B71533'>en&nbsp;a
      parlé avec lui.</span></b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>She talked
      to him about it.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>En&nbsp;&ecirc;tes-vous content?</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Are you
      pleased with it/them?</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Comment fait-on pour</span></b><span lang=FR style='font-size:
      12.0pt;font-family:"inherit",serif'>&nbsp;<b><span style='color:#B71533'>y&nbsp;aller?</span></b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>How do you
      get there?</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>N’y&nbsp;pense plus.</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Don’t
      think about it any more.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>In orders and instructions telling someone to do something,&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>en</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;or&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>y</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;come&nbsp;AFTER&nbsp;the
    verb and are attached to it with a hyphen (-).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Prenez-en.</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Take some.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Restez-y.</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Stay
      there.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>TipThe
    final&nbsp;</span><b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:#B71533'>-s</span></b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>&nbsp;of&nbsp;</span><b><span style='font-size:13.5pt;font-family:
    "inherit",serif;color:#B71533'>-er</span></b><span style='font-size:13.5pt;
    font-family:"inherit",serif;color:black'>&nbsp;verbs is usually dropped in
    the&nbsp;</span><b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:#B71533'>tu</span></b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>&nbsp;form used for orders and instructions. When an&nbsp;</span><b><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:#B71533'>-er</span></b><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>&nbsp;verb in
    the&nbsp;</span><b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:#B71533'>tu</span></b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>&nbsp;form is used before&nbsp;</span><b><span style='font-size:
    13.5pt;font-family:"inherit",serif;color:#B71533'>en</span></b><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>&nbsp;or&nbsp;</span><b><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:#B71533'>y</span></b><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>, however,
    the&nbsp;</span><b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:#B71533'>-s</span></b><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>&nbsp;is not dropped, to make it easier to say.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Donne des bonbons &agrave; ton fr&egrave;re.</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Give some
      sweets to your brother.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=FR style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Donnes-en&nbsp;&agrave; ton fr&egrave;re.</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Give some
      to your brother.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Va dans ta chambre!</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Go to your
      room!</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Vas-y!</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Go on!</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on the</span></i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;<b><i>Imperative</i></b><i>,
    see&nbsp;<a
    href="https://grammar.collinsdictionary.com/french-easy-learning/the-imperative"
    title="Explanation of The imperative"><span style='color:blue;text-decoration:
    none'>The imperative</span></a>.</i></span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;and&nbsp;</span><b><span style='font-size:12.0pt;font-family:
    "inherit",serif;color:#B71533'>y</span></b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;come&nbsp;AFTER&nbsp;other
    direct or indirect object pronouns.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Donnez-leur-en.</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Give them
      some.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif;
      color:#B71533'>Il</span></b><span style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b><span
      style='color:#B71533'>m’en&nbsp;a parlé.</span></b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>He spoke
      to me about it.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on</span></i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;<b><i>Direct object pronouns</i></b>&nbsp;<i>and<b>&nbsp;Indirect
    object pronouns</b>, see&nbsp;<a
    href="https://grammar.collinsdictionary.com/french-easy-learning/personal-pronouns-direct-object"
    title="Explanation of Personal pronouns: direct object"><span style='color:
    blue;text-decoration:none'>Personal pronouns: direct object</span></a>&nbsp;and&nbsp;<a
    href="https://grammar.collinsdictionary.com/french-easy-learning/personal-pronouns-indirect-object"
    title="Explanation of Personal pronouns: indirect object"><span
    style='color:blue;text-decoration:none'>Personal pronouns: indirect object</span></a>.</i></span></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:#E1E4EE'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>Key points</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;is used with verbs and expressions normally followed
    by&nbsp;</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>de</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;to avoid repeating the same word.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;can also replace the partitive article.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>When&nbsp;</span><b><span style='font-size:12.0pt;font-family:
    "inherit",serif;color:black'>en</span></b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:#B71533'>&nbsp;is used with&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>avoir</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;and&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>il y a</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;or
    with numbers, it is often not translated in English but can never be missed out
    in French.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>y</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;is used with verbs and expressions normally followed
    by&nbsp;</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&agrave;</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;to avoid repeating the same word.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>y</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;can also mean&nbsp;</span><i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>there</span></i><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;and
    may replace expressions that would be used with&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>dans</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;and&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>sur</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;or
    some other preposition indicating a place.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;and&nbsp;</span><b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>y</span></b><span style='font-size:
    12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;usually come before the
    verb, except in orders and instructions telling someone to do something,
    when&nbsp;</span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;or&nbsp;</span><b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>y</span></b><span style='font-size:
    12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;follows the verb and is
    attached to it with a hyphen.</span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>en</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>&nbsp;and&nbsp;</span><b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>y</span></b><span style='font-size:
    12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;come after other direct
    or indirect object pronouns.</span></p>
    
    <p class=MsoNormal>&nbsp;</p>
    
    </div>

`;
}
